export const hexToRgb = (hex) => {
  if (!hex) return "239,68,68"
  const cleaned = hex.replace("#", "")
  const r = parseInt(cleaned.substring(0, 2), 16)
  const g = parseInt(cleaned.substring(2, 4), 16)
  const b = parseInt(cleaned.substring(4, 6), 16)
  return `${r},${g},${b}`
}

export const hexToRgba = (hex, alpha) => {
  const normalized = hex.replace("#", "")

  const full =
    normalized.length === 3
      ? normalized
          .split("")
          .map((char) => char + char)
          .join("")
      : normalized

  const r = parseInt(full.slice(0, 2), 16)
  const g = parseInt(full.slice(2, 4), 16)
  const b = parseInt(full.slice(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const formatHourLabels = (labels = []) =>
  labels.map((label) => label.slice(5).replace("-", "."))

export const getDayBackgroundColor = (hasData, isBeforeAndSameDate, ratio, resourceColor) => {
  if (hasData && isBeforeAndSameDate) {
    return hexToRgba(resourceColor, 0.25 + ratio * 0.75)
  }

  if (isBeforeAndSameDate) {
    return "#d5e7eb"
  }

  return "#efefef"
}
